<template>
  <section class="max-w-[480px]">
    <div class="w-full h-3 bg-[#f2f2f2]" />

    <div class="p-16 flex items-center justify-between">
      <BlTextAv variation="body-16" tag="h2" weight="bold">Lembaga Penyedia Kelas</BlTextAv>
      <router-link class="no-underline" to="/lembaga">
        <BlTextAv variation="caption-12" class="lihat-semua-btn text-[#2B4AC7]" weight="medium">Lihat Semua</BlTextAv>
      </router-link>
    </div>

    <div class="relative flex items-start justify-between ph-16 pb-16 pt-8 max-w-[480px] overflow-hidden">
      <div class="relative z-10 overflow-hidden bg-[#3A5FD6] min-w-[148px] w-[148px] rounded">
        <div class="absolute top-[-30px] left-[-27px] bg-[#4179F0] w-[129px] h-[129px] rounded-full"></div>
        <div class="z-10 relative p-12 pb-20">
          <BlIllustrationAv class="pb-8" width="64" name="img_small_toa_promo_announcement" />
          <BlTextAv class="leading-4" variation="caption-12" color="inverse">
            25+ LPK telah bergabung bersama kami. Lembaga kamu selanjutnya?
          </BlTextAv>
          <BlButtonAv
            href="https://www.bukalapak.com/promo-campaign/daftar-mitra-prakerja-bukalapak"
            size="extra-small"
            variation="outline"
            fullwidth
            class="bg-white border-0 mt-12"
          >
            Daftar sekarang
          </BlButtonAv>
        </div>
      </div>

      <div class="grid grid-cols-3 md:grid-cols-4 gap-4">
        <div v-for="(merchantIcon, i) in merchantIcons" :key="i" class="flex justify-center items-center">
          <img v-if="merchantIcon.img" :src="merchantIcon.img" :alt="merchantIcon.alt" width="52" height="52" class="md:w-14 md:h-14" />
          <div v-else class="w-7 h-7 md:hidden"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {BlButtonAv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {BlIllustrationAv} from '@bukalapak/bazaar-visual-next';

export default {
  name: 'PrakerjaMerchantRegistrationBanner',
  components: {
    BlButtonAv,
    BlIllustrationAv,
    BlTextAv,
  },
  data() {
    return {
      merchantIcons: [
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-skill-academy.png'), alt: 'Logo Skill Academy'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-baba-studio.png'), alt: 'Logo Baba Studio'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-luar-sekolah.png'), alt: 'Logo Luar Sekolah'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-geti.png'), alt: 'Logo Geti'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-baking-world.png'), alt: 'Logo Baking World'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-hacktiv8.png'), alt: 'Logo Hacktiv8'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-kelas.png'), alt: 'Logo Kelas'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-siap-kerja.png'), alt: 'Logo Siap Kerja'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-studilmu.png'), alt: 'Logo Studilmu'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-cakap.png'), alt: 'Logo Cakap'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-pijar.png'), alt: 'Logo Pijar'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-zenius.png'), alt: 'Logo Zenius'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-g2-academy.png'), alt: 'Logo G2 Academy'},
        {img: this.$publicUrl('images/kartu-prakerja/logo-merchants/logo-kariermu.png'), alt: 'Logo Kariermu'},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.merchant-icons {
  margin-top: -8px;
  @media (max-width: 480px) {
    margin-left: -24px;
    margin-right: -40px;
  }
}
</style>
